<!--
// app/components/pages/region-home/MenaLandingHome.vue
-->
<script setup lang="ts">
import HubSpotForm from "~/app/components/pages/region-tickets/HubSpotForm.vue";
import BannerJoinTheDraft from "~/app/components/Shared/landings/BannerJoinTheDraft.vue";

const bgMenaLanding = "/img/landings/bg-landing-mena.jpg";
const formId = "8820e94c-b3f8-46ae-9d07-3097456c70d4";
const linkDraft = "https://mena.apply.kingsleague.pro/";

const showJoinDraft = ref(true);
const withVideo = true;

const { setLocaleCookie } = useI18n();

setLocaleCookie("en");

useSeoMeta({
  description: "Kings League – كرة القدم الحقيقية",
  ogDescription: "Kings League – كرة القدم الحقيقية",
});
</script>

<template>
  <section
    class="mx-auto min-h-screen md:min-h-[calc(100vh-20vh)] bg-cover bg-right-top bg-no-repeat md:py-20"
    :style="`background-image:url('${bgMenaLanding}');`"
  >
    <div class="max-w-6xl mx-auto">
      <div class="flex flex-col md:flex-row justify-between gap-6 items-center">
        <banner-join-the-draft
          v-if="showJoinDraft && withVideo"
          :draft-form-link="linkDraft"
          league-logo="/img/league-logos/kl-mena.png"
          league-logo-alt="Kings League MENA"
          button-text="انضم إلى الدرافت"
          claim-before-button="انضم إلى دوري الملوك وكن لاعبًا!"
          only-mobile
        ></banner-join-the-draft>
        <div class="md:max-w-lg px-4">
          <h1 class="text-primary text-3xl uppercase font-bold font-[termina]">
            من الرياض تبدأ قصة كينقز ليق مينا!
          </h1>

          <p class="mt-8">
            فِرق يقودها أشهر الستريمرز في الشرق الأوسط وشمال أفريقيا، جاهزة تتنافس بقوة على اللقب.
          </p>

          <p class="my-4">
            نظام جديد يجمع بين الرياضة والترفيه، وقواعد ثورية تجعل المباريات أكثر حماس ومتعة.
          </p>

          <p class="font-bold my-4">
            سجّل الآن وخلّك أول من يعرف كل جديد، أو قدّم طلبك وانضم للتاريخ مع أول نسخة من كينقز ليق مينا!
          </p>

          <div class="min-h-[378px] max-w-md">
            <hub-spot-form :form-id="formId" src="//js-eu1.hsforms.net/forms/embed/v2.js" />
          </div>
        </div>

        <div v-if="!withVideo" class="order-first w-full md:order-2 md:w-[771px] h-full flex justify-center">
          <banner-join-the-draft
            v-if="showJoinDraft"
            :draft-form-link="linkDraft"
            league-logo="/img/league-logos/kl-mena.png"
            league-logo-alt="Kings League MENA"
            button-text="انضم إلى الدرافت"
            claim-before-button="انضم إلى دوري الملوك وكن لاعبًا!"
          ></banner-join-the-draft>
          <img
            v-else
            src="/img/league-logos/kl-mena.png"
            alt="Kings League MENA"
            class="my-4 max-w-[225px] md:max-w-[350px]"
          />
        </div>

        <div
          v-if="withVideo"
          class="md:flex flex-col items-center md:items-start justify-center h-auto max-w-full mb-6 md:mb-0 px-4"
        >
          <iframe
            height="350"
            width="100%"
            class="max-w-[771px] max-h-[235px] sm:max-h-none aspect-video rounded-3xl outline-none"
            src="https://www.youtube-nocookie.com/embed/jz32Wy0BrEg?rel=0"
            title="Kings League MENA"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>

          <div class="hidden md:block self-center min-w-[50%]">
            <p class="mt-4 md:mt-6 !mb-2 text-sm sm:text-base md:text-lg text-center">
              انضم إلى دوري الملوك وكن لاعبًا!
            </p>
            <a :href="linkDraft" target="_blank" class="block btn btn-emphasis text-center">
              <span class="font-bold font-['Termina'] leading-none uppercase">انضم إلى الدرافت</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
